module.exports = __webpack_public_path__ + "f953d21136f7c157fdf0a17b4c0dbbeb.svg";